import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empresa',
  template: `
  <div>
  <router-outlet></router-outlet>
  </div>
  <!-- <app-footer-empresa></app-footer-empresa> -->
  `,
  styleUrls: []
})
export class EmpresaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    console.log("empresa.component");
  }

}
